
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/video",
      function () {
        return require("private-next-pages/ru/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/video"])
      });
    }
  